import { render, staticRenderFns } from "./orderCgWxddApprove.vue?vue&type=template&id=3ec840f6&scoped=true"
import script from "./orderCgWxddApprove.vue?vue&type=script&lang=js"
export * from "./orderCgWxddApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgWxddApprove.vue?vue&type=style&index=0&id=3ec840f6&prod&scoped=true&lang=css"
import style1 from "./orderCgWxddApprove.vue?vue&type=style&index=1&id=3ec840f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec840f6",
  null
  
)

export default component.exports